export default __webpack_public_path__ + "static/media/black-m.56b94f09.jpg";